<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{ routeName }}</a>
      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <drop-down
            class="nav-item"
            :title="auth.user.firstName"
            title-classes="nav-link"
            icon="ti-user"
            :is-open="dropdownOpen"
            @change="toggleDropdown"
          >
            <router-link class="dropdown-item" :class="{'active-link': $route.path === '/dashboard/admin/profile'}" to="/dashboard/admin/profile" @click="closeDropDown">Profile</router-link>
            <router-link class="dropdown-item" :class="{'active-link': $route.path === '/dashboard/change-password'}" to="/dashboard/change-password" @click="closeDropDown">Change Password</router-link>
            <div class="dropdown-item" @click="logout">Logout</div>
          </drop-down>
          <!-- <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-settings"></i>
              <p>
                Settings
              </p>
            </a>
          </li> -->
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    ...mapState(["auth"]),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      dropdownOpen: false,
    };
  },
  methods: {
    ...mapActions(["logout"]),
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen; 
    },
    closeDropDown() {
      this.dropdownOpen = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
};
</script>

<style>
.nav-item {
  width: 150px;
}

.dropdown-item {
  padding: 5px 0 5px 10px !important;
}

.active-link {
  background-color: grey !important;
  color: #f1f1f1 !important;
}
</style>
